import React from 'react'
import { ExternalLink, Phone, Star } from 'lucide-react'

import { SkeletonForFavorites } from 'src/features/SkeletonForFavorites'
import { TooltipWrapper } from 'src/components/Tooltip'

import {
  Table,
  TableBody,
  TableCell,
  TableRow,
} from 'src/components/shadcn/table'
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from 'src/components/shadcn/card'
import { Button } from 'src/components/shadcn/button'
import { Badge } from 'src/components/shadcn/badge'
import { useFavoritesContacts } from 'src/components/FavoritesContacts/useFavoritesContacts'
import {
  TABLE_PHONE_ICON_SIZE,
  TABLE_STAR_ICON_SIZE,
  TITLE_STAR_ICON_SIZE,
} from 'src/components/FavoritesContacts/constants'

export const FavoritesContacts = () => {
  const {
    favoriteContacts,
    handleCall,
    locale,
    isLoadingGetContacts,
    favoriteContactsCount,
    handleNavigateToContacts,
    serviceTypeDictionary,
    mainThemeColor,
    hiddenOnMobile,
  } = useFavoritesContacts()

  return (
    <Card>
      <CardHeader>
        <CardTitle>
          <div className="flex justify-between">
            <div className="flex gap-2 mt-2">
              <div className="text-[#fcd800]">
                <Star
                  size={TITLE_STAR_ICON_SIZE}
                  fill="currentColor"
                  stroke="none"
                />
              </div>
              <p>{locale.title}</p>
            </div>
            <TooltipWrapper text={locale.tooltip.goToContacts}>
              <Button
                size="iconCustom"
                variant="ghost"
                className="rounded-[10px]"
                onClick={handleNavigateToContacts}
              >
                <ExternalLink />
              </Button>
            </TooltipWrapper>
          </div>
        </CardTitle>
        <CardDescription>
          {`${locale.descriptionPartOne} ${favoriteContactsCount} ${locale.descriptionPartTwo}`}
        </CardDescription>
      </CardHeader>
      <CardContent className="p-6 pt-0">
        <div className="space-y-8">
          {isLoadingGetContacts ? (
            <div>
              <SkeletonForFavorites />
            </div>
          ) : favoriteContacts && favoriteContacts?.length > 0 ? (
            <Table className="w-full table-auto">
              <TableBody>
                {favoriteContacts?.map(contact => (
                  <TableRow key={contact.id}>
                    <TableCell>
                      <div className="flex gap-2">
                        <div className="text-[#fcd800]">
                          <Star
                            size={TABLE_STAR_ICON_SIZE}
                            fill="currentColor"
                            stroke="none"
                          />
                        </div>
                        {contact.contactName}
                      </div>
                    </TableCell>
                    <TableCell className={hiddenOnMobile}>
                      <Badge
                        variant="outline"
                        className="select-none"
                        style={{
                          color: mainThemeColor,
                          borderColor: mainThemeColor,
                        }}
                      >
                        {contact.phoneNumber}
                      </Badge>
                    </TableCell>
                    <TableCell className={hiddenOnMobile}>
                      {serviceTypeDictionary[contact.serviceType]}
                    </TableCell>
                    <TableCell className="text-right">
                      <button
                        className="text-green-500"
                        onClick={() => handleCall(contact.phoneNumber)}
                      >
                        <Phone size={TABLE_PHONE_ICON_SIZE} />
                      </button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          ) : (
            <div className="flex justify-center">
              <Button
                variant="outline"
                className="text-center mt-20 rounded-[10px]"
                onClick={handleNavigateToContacts}
              >
                {locale.noResult}
              </Button>
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  )
}
